import type { StepStatus, StepperSize } from './stepperTypes';

/**
 * Size configurations for Stepper
 */
export const stepperSizeStyles: Record<
  StepperSize,
  {
    circle: string;
    label: string;
    description: string;
    connector: string;
    connectorVertical: string;
  }
> = {
  sm: {
    circle: 'w-8 h-8 text-sm',
    label: 'text-sm',
    description: 'text-xs',
    connector: 'h-0.5',
    connectorVertical: 'w-0.5',
  },
  md: {
    circle: 'w-10 h-10 text-base',
    label: 'text-base',
    description: 'text-sm',
    connector: 'h-0.5',
    connectorVertical: 'w-0.5',
  },
  lg: {
    circle: 'w-12 h-12 text-lg',
    label: 'text-lg',
    description: 'text-base',
    connector: 'h-1',
    connectorVertical: 'w-1',
  },
};

/**
 * Status styles for Stepper
 */
export const statusStyles: Record<StepStatus, { circle: string; icon: string }> = {
  completed: {
    circle: 'bg-success/80 border-success/40',
    icon: 'text-white',
  },
  current: {
    circle: 'bg-primary/80 border-primary/40',
    icon: 'text-white',
  },
  upcoming: {
    circle: 'bg-white/[0.06] border-white/[0.15]',
    icon: 'text-surface-500',
  },
  error: {
    circle: 'bg-error/80 border-error/40',
    icon: 'text-white',
  },
};
